module.exports = __webpack_public_path__ + "img/card-profile4.83bb1a63.jpg";